module.exports = __webpack_public_path__ + "static/media/group-appt.92030a9f.svg";